export const SET_CLOSING_RATIO_LOADING = 'SET_CLOSING_RATIO_LOADING'
export const GET_CLOSING_RATIO_DATA = 'GET_CLOSING_RATIO_DATA'
export const GET_TEAM_CLOSING_RATIO_DATA = 'GET_TEAM_CLOSING_RATIO_DATA'
export const REMOVE_ITEM_FROM_DATA = 'REMOVE_ITEM_FROM_DATA'
export const CALCULATE_PREDICTED_DATA = 'CALCULATE_PREDICTED_DATA'
export const CLEAR_CLOSING_RATIO_DATA = 'CLEAR_CLOSING_RATIO_DATA'
